import { typedEntries } from '@soundxyz/utils';
import { EditedAuctionConfigFields, editedAuctionConfigState } from './fields/auctionConfig';
import { clearAuctionConfigErrors } from './helpers';

export const validateEditedAuctionConfigState = () => {
  clearAuctionConfigErrors();

  const result = EditedAuctionConfigFields.safeParse(editedAuctionConfigState.fields);

  if (!result.success) {
    typedEntries(result.error.format().editedSaleSchedules || {}).forEach(([key, value]) => {
      if (key === '_errors') return;

      editedAuctionConfigState.errors[key] = value['_errors']?.[0];
    });

    typedEntries(result.error.format().allowlists || {}).forEach(([key, value]) => {
      if (key === '_errors') return;

      editedAuctionConfigState.errors[key] = value['_errors']?.[0];
    });
    editedAuctionConfigState.isValid = false;
    return;
  }

  editedAuctionConfigState.isValid = true;
  return result.data;
};
